export default __webpack_public_path__ + "assets/fonts/toolbar-icon.7cf5ae16c7f1492c856da5ce8b2ce726.ttf";